/**
 * 2026 Survey page
 * - noindex for crawlers
 * - Full-width iframe (no max-width containers)
 * - Standard header and footer navigation
 * - Tally survey embed (static)
 */

import React, { useEffect, useState } from 'react';

import Layout from '../components/layout';
import Seo from '../components/seo';

const BASE_TALLY_URL = 'https://tally.so/embed/RGz0XJ';
const BASE_TALLY_PARAMS =
  'alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1';
const EMBED_TITLE = 'Revolution 2026 Survey';

const buildTallyUrl = (search) => {
  const params = new URLSearchParams(BASE_TALLY_PARAMS);
  if (search) {
    const incoming = new URLSearchParams(search);
    incoming.forEach((value, key) => params.set(key, value));
  }
  return `${BASE_TALLY_URL}?${params.toString()}`;
};

const loadTallyEmbeds = () => {
  if (typeof window === 'undefined') return;
  const d = document;
  const w = 'https://tally.so/widgets/embed.js';
  const v = function () {
    if (typeof Tally !== 'undefined') {
      Tally.loadEmbeds();
    } else {
      d.querySelectorAll('iframe[data-tally-src]:not([src])').forEach((e) => {
        e.src = e.dataset.tallySrc;
      });
    }
  };
  if (typeof Tally !== 'undefined') {
    v();
  } else if (!d.querySelector(`script[src="${w}"]`)) {
    const s = d.createElement('script');
    s.src = w;
    s.onload = v;
    s.onerror = v;
    d.body.appendChild(s);
  }
};

const Survey2026Page = ({ location }) => {
  const [embedUrl, setEmbedUrl] = useState(() =>
    buildTallyUrl(typeof window !== 'undefined' ? window.location.search : '')
  );

  useEffect(() => {
    const search =
      location?.search ||
      (typeof window !== 'undefined' ? window.location.search : '');
    setEmbedUrl(buildTallyUrl(search));
  }, [location?.search]);

  useEffect(() => {
    loadTallyEmbeds();
  }, [embedUrl]);

  return (
    <Layout headerSolid>
      <Seo
        title={EMBED_TITLE}
        description=""
        meta={[
          {
            name: 'robots',
            content: 'noindex',
          },
        ]}
      />
      {/* Full-width iframe - no xl:container or max-width constraints, minimal side padding */}
      <div className="pt-header-height-mobile lg:pt-header-height-desktop w-full min-h-screen px-4 md:px-6 lg:px-8">
        <iframe
          data-tally-src={embedUrl}
          loading="lazy"
          width="100%"
          height="200"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title={EMBED_TITLE}
          className="block border-0 w-full"
        />
      </div>
    </Layout>
  );
};

export default Survey2026Page;
